import { animate } from "motion";

const initBulletListSlideshow = () => {
    const slideshowContainers = document.querySelectorAll(".bullet-list__slides");

    slideshowContainers.forEach((container) => {
        const slides = container.querySelectorAll(".bullet-list__slide");

        if (slides.length <= 1) return;

        let currentSlideIndex = 0;

        // Create inner wrapper for relative positioning context
        const slideWrapper = document.createElement("div");
        slideWrapper.style.position = "relative";
        slideWrapper.style.width = "100%";
        slideWrapper.style.height = "100%";

        // Move all slides into the wrapper
        slides.forEach((slide) => {
            slideWrapper.appendChild(slide);
        });
        container.appendChild(slideWrapper);

        // Set initial state - hide all slides except first
        slides.forEach((slide, index) => {
            slide.style.position = "absolute";
            slide.style.top = "0";
            slide.style.right = "0";
            slide.style.opacity = index === 0 ? "1" : "0";
        });

        const cycleThroughSlides = () => {
            const currentSlide = slides[currentSlideIndex];
            const nextSlideIndex = (currentSlideIndex + 1) % slides.length;
            const nextSlide = slides[nextSlideIndex];

            // Fade out current slide and fade in next slide simultaneously
            animate(currentSlide, { opacity: 0 }, { duration: 0.5, ease: "easeInOut" });
            animate(nextSlide, { opacity: 1 }, { duration: 0.5, ease: "easeInOut" });

            currentSlideIndex = nextSlideIndex;
        };

        setInterval(cycleThroughSlides, 1500);
    });
};

document.addEventListener("DOMContentLoaded", initBulletListSlideshow);

// Also initialize if DOM is already loaded (for dynamic content)
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBulletListSlideshow);
} else {
    initBulletListSlideshow();
}
